import React, { memo, useEffect, useRef } from "react";
import InfoIcon from "@/src/assets/InfoIcon";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInCr,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
} from "../../../Common/utils/GameUtils";
import QualifiedPlayerSheet from "./QualifiedPlayerSheet";
import { requestFlightTourneyStackDetails } from "@/Poker/redux/slices/lobbySlice";
import { useDispatch } from "react-redux";
import { format } from "date-fns";

const TourneyInfoCard = ({ tourneyDetails, activeTab }) => {
  const dispatch = useDispatch();

  const elementRef = useRef(null);
  const stackDetails = tourneyDetails?.stackDetails
    ? tourneyDetails?.stackDetails
    : null;

  useEffect(() => {
    if (!stackDetails) {
      dispatch(
        requestFlightTourneyStackDetails({
          tourneyId: tourneyDetails.tourneyId,
        })
      );
    }
    if (elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  console.log("stackDetails: ", stackDetails);
  return (
    <div ref={elementRef}>
      <div className="flex items-center justify-center px-2 py-3">
        <div className="w-1/3 flex flex-col items-center">
          <div className="text-secondary text-2xs">Buy-In</div>
          <div className="text-primary font-medium mt-1 text-2xs">
            {`${
              parseDecimalValuesOfNumber(
                stackDetails?.buyIn,
                2,
                checkToDisplayValueInK(stackDetails?.buyIn),
                checkToDisplayValueInL(stackDetails?.buyIn),
                checkToDisplayValueInCr(stackDetails?.buyIn)
              ) || 0
            }`}
            {/* {stackDetails?.buyIn} */}
          </div>
        </div>
        <div className="w-1/3 flex flex-col items-center border-x border-light/35">
          <div className="text-secondary text-2xs">Total Entries</div>
          <div className="text-primary font-medium mt-1 text-2xs">
            {stackDetails?.numberOfEntries || 0}
          </div>
        </div>
        {activeTab == "similar" ? (
          <div className="w-1/3 flex flex-col items-center">
            <QualifiedPlayerSheet
              stackDetails={stackDetails}
              tourneyDetails={tourneyDetails}
            />
          </div>
        ) : (
          <div className="w-1/3 flex flex-col items-center">
            <div className="text-secondary text-2xs">Tickets Awarded</div>
            <div className="flex items-center">
              <div className="text-success font-medium mt-1 text-2xs mr-1">
                {stackDetails?.numberOfTicketsAssigned || 0}
              </div>
            </div>
          </div>
        )}
      </div>
      {activeTab == "similar" && (
        <div className="flex items-center justify-center px-2 py-3">
          <div className="w-1/3 flex flex-col items-center">
            <div className="text-secondary text-2xs">Smallest Stack</div>
            <div className="text-primary font-medium mt-1 text-2xs">
              {stackDetails?.minStack}
            </div>
          </div>
          <div className="w-1/3 flex flex-col items-center border-x border-light/35">
            <div className="text-secondary text-2xs">Average Stack</div>
            <div className="text-primary font-medium mt-1 text-2xs">
              {stackDetails?.averageStack}
            </div>
          </div>
          <div className="w-1/3 flex flex-col items-center">
            <div className="text-secondary text-2xs">Largest Stack</div>
            <div className="text-primary font-medium mt-1 text-2xs mr-1">
              {stackDetails?.maxStack}
            </div>
          </div>
        </div>
      )}
      {activeTab == "similar" && stackDetails?.qualified && (
        <div className="text-2xs text-secondary  font-medium mb-2 text-center">
          {`You qualified with ${stackDetails?.qualifiedStack} chips`}
        </div>
      )}
      {stackDetails?.startedDate && (
        <div className="flex items-center justify-between px-3 py-2 bg-background">
          {stackDetails?.startedDate && (
            <div className="flex items-center text-primary text-2xs">
              <div className="">Started:</div>
              <div className="font-medium">
                {format(
                  new Date(stackDetails?.startedDate * 1000),
                  "dd MMM, hh:mm a"
                )}
              </div>
            </div>
          )}
          {stackDetails?.endedDate && (
            <div className="flex items-center text-primary text-2xs">
              <div className="">Ended:</div>
              <div className="font-medium">
                {format(
                  new Date(stackDetails?.endedDate * 1000),
                  "dd MMM, hh:mm a"
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(TourneyInfoCard);
